import request from "@/api";

export function listPermission(data) {
    return request({
        url: '/api/permission/getPermissionList',
        method: 'get',
        params: data
    })
}
export function savePermission(data) {
    return request({
        url: '/api/permission/savePermission',
        method: 'post',
        data: data
    })
}

export function deletePermission(data) {
    return request({
        url: '/api/permission/deletePermission',
        method: 'post',
        data: data
    })
}
